<smart-input [hideDescription]="true" translationPrefix="driver." [(model)]="step" key="element"></smart-input>
<smart-input [hideDescription]="true" translationPrefix="driver." [(model)]="step" key="title"></smart-input>
<smart-input [hideDescription]="true" translationPrefix="driver." [(model)]="step" key="description"></smart-input>
<button (click)="save()" color="primary" mat-button mat-raised-button>Save</button>
